export const TWO_FACTOR_BACKUP_LOGIN_ALERT_KEY = 'two_factor_backup_login_alert'

export function setTwoFactorBackupLoginAlert (): void {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  sessionStorage.setItem(TWO_FACTOR_BACKUP_LOGIN_ALERT_KEY, '1')
}

export function consumeTwoFactorBackupLoginAlert (): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false
  }

  const shouldShow = sessionStorage.getItem(TWO_FACTOR_BACKUP_LOGIN_ALERT_KEY) === '1'

  if (shouldShow) {
    sessionStorage.removeItem(TWO_FACTOR_BACKUP_LOGIN_ALERT_KEY)
  }

  return shouldShow
}
